var slideIcon = new Swiper('.slide-icon', {
    slidesPerView: 'auto', 
    centeredSlides: false, 
    spaceBetween:10,
    breakpoints: { 

      769: {

      },
      1024: {


      },
      1400: {
       spaceBetween:20,

      },
    }
});

/*로고 자동 스크롤*/
var slideCollection = new Swiper('.logo_scroll', {
    slidesPerView: 1.8, 
    loop:true,
    speed:5000,
    autoplay:{
        delay : 0,
        disableOnInteraction : false,
    },
  breakpoints: { 

      769: {
       slidesPerView: 4.5, 
      },
      1024: {

       slidesPerView: 5, 
      },
      1400: {
       slidesPerView: 6, 


      },
    }

});